module.exports = __webpack_public_path__ + "img/hero-frame.19b68820.png";